import { createContext, useContext } from 'react';
import { CoKitchenPolygons, CoKitchenType } from 'utils/types';

export type CokitchenContextType = {
  activeKitchen: CoKitchenType;
  setActiveKitchen: (activeKitchen: CoKitchenType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  kitchenLoading: boolean;
  setKitchenLoading: (arg1: boolean) => void;
  createCokitchenForm: CoKitchenType;
  setCreateCokitchenForm: (k: CoKitchenType) => void;
  editCokitchenForm: CoKitchenType;
  setEditCokitchenForm: (k: CoKitchenType) => void;
  activePolygon: CoKitchenPolygons;
  setActivePolygon: (arg0: CoKitchenPolygons) => void;
  cokitchenPolygons: CoKitchenPolygons[];
  setCokitchenPolygons: (arg0: CoKitchenPolygons[]) => void;
  newCokitchen: CoKitchenType | null;
  setNewCokitchen: (c: CoKitchenType | null) => void;
};

export const CokitchenContext = createContext({} as CokitchenContextType);

const useCokitchenContext = () => {
  const context = useContext(CokitchenContext);
  return context;
};

export default useCokitchenContext;
